import { createSlice } from '@reduxjs/toolkit';
import LocalStorageManager from '../../Utils/localstorage.js';


const initialState = {
  isLoading: true,
  user: {},
  tokens: {
    token: LocalStorageManager.get('evChAccessToken') || null,
    refreshToken: LocalStorageManager.get('evChRefreshToken') || null
  },
  error: null,
  success: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.isLoading = false
      state.user = action.payload;
    },
    resetUser: (state, action) => {
      state.user = {};
    },
    setAccessToken: (state, action) => {
      const { token, refreshToken } = action.payload;
      state.isLoading = false
      state.tokens = {
        ...state.tokens,
        token,
        ...(refreshToken ? { refreshToken } : {})
      };
    },
    logout: (state, action) => {
      LocalStorageManager.delete('evChAccessToken');
      LocalStorageManager.delete('evChRefreshToken');
      state.isLoading = false
      state.tokens = null;
      state.user = {};
    }
  }
});

export const { setUser, logout, setAccessToken, resetUser } = authSlice.actions;

export default authSlice.reducer;
